import React, { useState } from "react";
import { Textbox } from "../../global/components/inputs/textbox/textbox";
import { IEpiProps, ISearchResult, SearchContext } from "../models/vertex-search-page-models";
import { useVertexSearchContext, useVertexSearchDispatch } from "../reducers/vertex-search-page-provider";
import { SearchResultPrice } from "./search-result-price";

interface IProps {
}

interface IContextProps {
    epiProps: IEpiProps
    currentSearchContext: string
    showHealthyChildrenBranding: boolean
    healthyChildrenUrl: string
}

export const SearchHeading = (props: IProps) => {
    const { epiProps, currentSearchContext, showHealthyChildrenBranding, healthyChildrenUrl }: IContextProps = useVertexSearchContext();
    let healthyChildrenLink = healthyChildrenUrl && healthyChildrenUrl.length > 0 ? healthyChildrenUrl : "http://www.healthychildren.org/";

    if (showHealthyChildrenBranding && currentSearchContext == SearchContext.HealthyChildren) {
        return (
            <div>
                <a className="vertex-search-hc-logo" href={healthyChildrenLink} target="_blank">
                    <img className="global-logo-hc-element" src="/Static/imgs/healthy-children-logo.png" />
                </a>
                <h1>{epiProps.healthyChildrenHeading}</h1>
                <p>{epiProps.healthyChildrenHeadingDescription}</p>
            </div>
        )
    }
    else if (currentSearchContext == SearchContext.HealthyChildren || currentSearchContext == SearchContext.AllAAP) {
        return (
            <div>
                <div className="vertex-search-directory">
                    <a href={epiProps.memberDirectoryLinkUrl} target="_blank">{epiProps.memberDirectoryLinkText}</a>
                </div>
                <h1>{epiProps.heading}</h1>
                <p>{epiProps.headingDescription}</p>
            </div>
        )
    }
    else {
        //SHOP context
        return (
            <div>
                <div className="vertex-search-directory">
                    <a href={epiProps.memberDirectoryLinkUrl} target="_blank">{epiProps.memberDirectoryLinkText}</a>
                </div>
                <h1>{epiProps.shopHeading}</h1>
                <p>{epiProps.shopHeadingDescription}</p>
            </div>
        )
    }
}